/* Honey Peak Quiz — tracker for the NOBO Quiz Analytics Google Sheet
   File: assets/honey-peak-quiz-tracker.js
   Sends the exact fields the sheet's doPost() reads:
   session_id, quiz_id, event, step, title, answer, is_multi, ua, ref, client_ts
   Events: view | answer | complete | cta
   Does nothing inside the Shopify theme editor. */
(function () {
  var ENDPOINT = 'https://script.google.com/macros/s/AKfycbxaMQt5maicUQGphRKRZNvtD24gnCIQL-k7gDWMxVSZx6tT0Um_M0SBH8X6tgpHaV6A/exec';
  var QUIZ_ID = 'honey-peak-quiz';

  function init() {
    var root = document.querySelector('[data-hpq]');
    if (!root || root.getAttribute('data-design-mode') === 'true') return;

    var steps = [].slice.call(root.querySelectorAll('[data-hpq-step]'));
    if (!steps.length) return;

    /* ---------- session ---------- */
    var sid = null;
    try { sid = sessionStorage.getItem('hpq_session_id'); } catch (e) {}
    if (!sid) {
      sid = 's_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8);
      try { sessionStorage.setItem('hpq_session_id', sid); } catch (e) {}
    }
    var ua = navigator.userAgent || '';
    var ref = document.referrer || '';
    var utm = location.search.match(/utm_[a-z]+=[^&]+/g);
    if (utm) ref = (ref ? ref + ' | ' : '') + utm.join('&');

    /* ---------- helpers ---------- */
    function clean(t, max) { return (t || '').replace(/\s+/g, ' ').trim().slice(0, max || 200); }

    function titleOf(el) {
      var h = el.querySelector('.step-heading, .motivational-heading, .social-proof-heading, .loading-heading');
      return clean(h ? h.textContent : '', 200) || el.getAttribute('data-type');
    }

    // Step numbers start at 1 (Q1 = first screen of the quiz)
    function send(event, idx, extra) {
      var el = steps[idx];
      var p = {
        session_id: sid,
        quiz_id: QUIZ_ID,
        event: event,
        step: idx + 1,
        title: el ? titleOf(el) : '',
        answer: '',
        is_multi: false,
        ua: ua,
        ref: ref,
        client_ts: new Date().toISOString()
      };
      if (extra) for (var k in extra) p[k] = extra[k];
      var body = JSON.stringify(p);
      try {
        if (navigator.sendBeacon && navigator.sendBeacon(ENDPOINT, new Blob([body], { type: 'text/plain;charset=UTF-8' }))) return;
      } catch (e) {}
      try {
        fetch(ENDPOINT, { method: 'POST', mode: 'no-cors', keepalive: true,
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: body });
      } catch (e) {}
    }

    /* ---------- step views ---------- */
    var current = -1, completed = false, ctaSent = false;
    function checkActive() {
      for (var i = 0; i < steps.length; i++) {
        if (steps[i].classList.contains('active')) {
          if (i !== current) {
            current = i;
            send('view', i);
            if (!completed && steps[i].getAttribute('data-type') === 'loading') {
              completed = true;
              send('complete', i);
            }
          }
          return;
        }
      }
    }
    var mo = new MutationObserver(checkActive);
    steps.forEach(function (s) { mo.observe(s, { attributes: true, attributeFilter: ['class'] }); });
    checkActive();

    /* ---------- answers ---------- */
    var multi = {}; // step index -> ordered list of picked labels

    root.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.closest) return;

      // Multi-choice "Continue" -> send all picked answers at once
      var cont = t.closest('[data-hpq-multi-continue]');
      if (cont) {
        var ci = steps.indexOf(cont.closest('[data-hpq-step]'));
        var picked = multi[ci] || [];
        if (picked.length) send('answer', ci, { answer: picked.join(' | '), is_multi: true });
        return;
      }

      // Single choice / image cards
      var opt = t.closest('.option-item, .age-card');
      if (opt) {
        var st = opt.closest('[data-hpq-step]');
        var idx = steps.indexOf(st);
        var lab = opt.querySelector('.age-card-label') || opt.querySelector('span');
        var label = clean(lab ? lab.textContent : opt.textContent, 200);
        if (st.getAttribute('data-type') === 'multi_choice') {
          var list = multi[idx] = multi[idx] || [];
          var pos = list.indexOf(label);
          if (pos >= 0) list.splice(pos, 1); else list.push(label);
        } else {
          send('answer', idx, { answer: label });
        }
      }
    }, true);

    /* ---------- redirect to product after the quiz = CTA ---------- */
    window.addEventListener('pagehide', function () {
      if (completed && !ctaSent) { ctaSent = true; send('cta', current); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();